import type { GeoMapMarker } from '@/shared/ui/map';
import type { StationDetailValue } from '../stationFormSchema';

/** Jednořádkový souhrn adresy: „Ulice čp/čo, Obec". */
export function addressSummary(place: StationDetailValue): string {
  const number = [place.descriptiveNumber, place.orientationNumber]
    .map((part) => part.trim())
    .filter(Boolean)
    .join('/');
  const line = [place.street.trim(), number].filter(Boolean).join(' ');
  return [line, place.city.trim()].filter(Boolean).join(', ');
}

/** Sestaví markery mapy: 1. místo = ★ hlavní, ostatní číslované; bez míst = ★ z vlastních souřadnic. */
export function buildMarkers(
  details: StationDetailValue[],
  stationLat: number | null,
  stationLng: number | null
): GeoMapMarker[] {
  const placeMarkers = details
    .map((detail, index) => ({ detail, index }))
    .filter(({ detail }) => detail.latitude != null && detail.longitude != null)
    .map(({ detail, index }) => ({
      key: detail.key,
      lat: detail.latitude as number,
      lng: detail.longitude as number,
      label: index === 0 ? '★' : String(index + 1),
      isMain: index === 0,
    }));
  if (placeMarkers.length > 0) {
    return placeMarkers;
  }
  if (stationLat != null && stationLng != null) {
    return [{ key: 'station', lat: stationLat, lng: stationLng, label: '★', isMain: true }];
  }
  return [];
}
